import * as React from "react";
import { Alert, Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { TargetKindOptions } from "../utils";
import { getDefaultQueryInput } from "../../../schema/types/query/input";
import { formSetValue, formTriggerValidation, useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpSwitch } from "../../gvc/testNewForm/CpSwitch";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";

export const TargetKind: React.FC = () => {
  const { id } = useCpFormContext();
  const targetKind = useCpFormValue(`targetKind`);
  const org = useAppSelector(selectOrg);

  const isOrgKind = targetKind === "org";

  React.useEffect(() => {
    if (["org", "task"].includes(targetKind)) {
      formSetValue(id, `targetAll`, true);
    }
    formSetValue(id, `targets`, []);
    formSetValue(id, `targetQuery`, getDefaultQueryInput());
    formTriggerValidation(id);
  }, [targetKind]);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Target</CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`targetKind`}>Kind</CpLabel>
                <CpTooltip tooltipProps={{ title: `Cannot be changed after creation` }} />
              </CpLabelTooltip>
              <CpSelect name={`targetKind`} options={TargetKindOptions} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`targetKind`} />
            </CpFormItem>
            {isOrgKind ? (
              <Alert
                type="info"
                showIcon
                message={`Policy target is this org (${org}) itself.`}
                style={{ width: "fit-content" }}
              />
            ) : (
              <CpFormItem>
                <div className="flex items-center gap-2">
                  <CpLabel name={`targetAll`}>Target All Items</CpLabel>
                  <CpSwitch name={`targetAll`} />
                  <CpTooltip
                    tooltipProps={{
                      title: `When checked, this policy applies to all items of this kind, otherwise you need to target items with a
                  selection and/or a query.`,
                    }}
                  />
                </div>
                <CpErrorWarning name={`targetAll`} />
              </CpFormItem>
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
